/**
 * EXPERIENCIAS APEX ANDES - SINGLE SOURCE OF TRUTH
 *
 * Turismo de autor en los paisajes más extraordinarios de Chile
 * La Parva Signature, Ruta del Vino, Mountain Services, Andes Lodge, Extras
 */

export interface Experience {
  id: string
  title: string
  shortTitle?: string
  description: string
  heroImage: string
  link: string
  subtitle?: string
  location?: string
  hidden?: boolean // Temporarily hide from frontend navigation (keeps page accessible via direct URL)
  bookingMode?: 'direct' | 'whatsapp' | 'hidden'
}

export const experiences: Experience[] = [
  {
    id: "laparva-signature",
    title: "La Parva Signature Experience",
    shortTitle: "La Parva",
    description: "Vivir la montaña en familia es una experiencia única. El silencio de la nieve, los amaneceres sobre la cordillera y los días de esquí se transforman en recuerdos para toda la vida.",
    heroImage: "/images/experiences/laparva/laparva-hero.webp",
    link: "/experiences/laparva-signature",
    subtitle: "A premium, worry-free mountain experience",
    location: "La Parva • Andes Chilenos",
    bookingMode: 'whatsapp'
  },
  {
    id: "wine-route",
    title: "Ruta del Vino de Chile",
    shortTitle: "Vino",
    description: "En el corazón del Valle de Colchagua se encuentran algunos de los vinos más reconocidos de Chile y del mundo. Santa Cruz es un pueblo encantador rodeado de viñedos, historia y paisajes suaves.",
    heroImage: "/images/experiences/wine/wine-hero.webp",
    link: "/experiences/wine-route",
    subtitle: "Santa Cruz & Apalta – El corazón del vino chileno",
    location: "Valle de Colchagua • Santa Cruz",
    bookingMode: 'whatsapp'
  },
  {
    id: "catamaran-trip",
    title: "Viaje en Catamarán",
    shortTitle: "Catamarán",
    description: "Navega en catamarán de lujo por algunas de las bahías más espectaculares de la costa chilena. Días de sol, agua cristalina, parrilla a bordo y atardeceres inolvidables.",
    heroImage: "/images/experiences/catamaran/catamaran-hero.webp",
    link: "/experiences/catamaran-trip",
    subtitle: "Navegación privada • Bahías exclusivas • Tripulación completa",
    location: "Costa de Chile",
    bookingMode: 'whatsapp'
  },
  {
    id: "private-dinners-santiago",
    title: "Cenas Privadas Santiago",
    shortTitle: "Cenas Privadas",
    description: "Una noche donde cada detalle fue pensado solo para ti. Chef de autor reconocido, lugar secreto con vistas increíbles y producción completa. No es un restaurante. Es tu restaurante, por una noche.",
    heroImage: "/images/experiences/private-dinners/dinner-hero.webp",
    link: "/experiences/private-dinners-santiago",
    subtitle: "Chef privado • Lugar secreto • Producción completa",
    location: "Santiago • Chile",
    bookingMode: 'whatsapp' as const
  },
  {
    id: "mountain-services",
    title: "Mountain Services",
    shortTitle: "Services",
    description: "Si ya tienes tu departamento reservado en La Parva, Farellones o El Colorado, pero quieres vivir la montaña con la tranquilidad de un servicio premium, este paquete es para ti.",
    heroImage: "/images/experiences/mountain-services/mountain-services-hero.webp",
    link: "/experiences/mountain-services",
    subtitle: "Servicio completo para tu estadía en la nieve (sin alojamiento)",
    location: "La Parva • Farellones • El Colorado",
    bookingMode: 'whatsapp'
  },
  {
    id: "andes-lodge",
    title: "Andes Lodge Experience",
    shortTitle: "Lodge",
    description: "Una experiencia pensada para quienes disfrutan viajar acompañados, compartir historias y vivir la montaña en comunidad. Te hospedas en una habitación dentro de un lodge cálido y acogedor.",
    heroImage: "/images/experiences/andes-lodge/andes-lodge-hero.webp",
    link: "/experiences/andes-lodge",
    subtitle: "Estancia social todo incluido en la montaña",
    location: "Andes Chilenos",
    hidden: true,
    bookingMode: 'whatsapp'
  },
  {
    id: "mountain-extras",
    title: "Experiencias Adicionales",
    shortTitle: "Extras",
    description: "Complementa tu estadía en la montaña con experiencias únicas: raquetteo al amanecer, randonnée experience, clases de esquí y snowboard, y traslados privados.",
    heroImage: "/images/experiences/extras/extras-hero.webp",
    link: "/experiences/mountain-extras",
    subtitle: "Add-ons disponibles para todos los paquetes",
    location: "Montaña • Viñedos",
    bookingMode: 'whatsapp'
  }
]

// Helper function to get experience by ID
export function getExperienceById(id: string): Experience | undefined {
  return experiences.find(experience => experience.id === id)
}

// Helper function to get only hero images
export function getExperienceHeroImages(): Record<string, string> {
  return experiences.reduce((acc, experience) => {
    acc[experience.id] = experience.heroImage
    return acc
  }, {} as Record<string, string>)
}
